document.addEventListener('DOMContentLoaded', function () {
  const productReferenceInfo = document.querySelector('.product-reference-info');
  if (!productReferenceInfo) {
    return;
  }

  const productReferenceInfoList = productReferenceInfo.querySelectorAll('.product-reference-info__list-title');
  const resizeItems = [];

  productReferenceInfoList.forEach(function (header) {
    const inner = header.parentElement.querySelector('.product-reference-info__inner');
    const content = header.parentElement.querySelector('.product-reference-info__list-content');
    const icon = header.querySelector('.product-reference-info__list-icon');
    if (!inner || !content || !icon) {
      return;
    }
    const getContentHeight = function () {
      return content ? content.scrollHeight : 0;
    };

    const updateHeight = function () {
      if (inner.classList.contains('open')) {
        inner.style.height = 'auto';
      } else {
        inner.style.height = '0px';
      }
    };

    updateHeight();
    resizeItems.push({ inner, getContentHeight });

    header.addEventListener('click', function () {
      if (inner.classList.contains('open')) {
        inner.style.height = getContentHeight() + 'px';
        inner.classList.remove('open');
        requestAnimationFrame(function () {
          inner.style.height = '0px';
        });
        icon.innerHTML = '<svg class="icon-plus" ><use href="#icon-plus"></use></svg>';
      } else {
        inner.classList.add('open');
        inner.style.height = getContentHeight() + 'px';
        icon.innerHTML = '<svg class="icon-minus" ><use href="#icon-minus"></use></svg>';
      }
    });
  });

  window.addEventListener('resize', function () {
    resizeItems.forEach(function (item) {
      if (item.inner.classList.contains('open')) {
        item.inner.style.height = 'auto';
      }
    });
  });
});
